import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { SMEs } from 'src/app/shared/models/constants';
import { StandardNamn } from 'src/app/shared/models/standard-namn';
import { SearchDTO, Gender, ResistanceCalculationResultDTO, SearchType } from '../../models/analys-resultat';
import { StandardNamnService } from '../../standard-namn/standard-namn.service';
import { AnalysresultatService } from '../analysresultat.service';

@Component({
    selector: 'app-general-search',
    templateUrl: './general-search.component.html',
    styleUrl: './general-search.component.scss',
    standalone: false
})
export class GeneralSearchComponent {
  protected searchType = SearchType.GENERAL;
}
